import styled from '@emotion/styled/macro';
import { theme } from 'styles/theme';

export const UserName = styled.span`
  font-family: ${theme.fonts.bold};
  font-size: ${theme.fontSizes.xs};
  transition: background-color 0.2s;
`;
